module.exports = __webpack_public_path__ + "static/img/heatmap2022.79cb0893.png";